import * as Sentry from '@sentry/react';
import posthog from 'posthog-js';

type ExceptionContext = {
  tags?: Record<string, string>;
  extra?: Record<string, unknown>;
  fingerprint?: string[];
};

// Dual-write so PostHog error tracking can be evaluated against Sentry on
// the same occurrences. Sentry stays the source of truth.
export const reportException = (
  error: unknown,
  context?: ExceptionContext,
): void => {
  Sentry.captureException(error, context);
  posthog.captureException(error, {
    ...context?.tags,
    ...context?.extra,
  });
};
